"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialiseCreateBlockButtonForEmptyProjectContainer = exports.mountCreateBlockButtonInBlock = void 0;
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var CreateBlockButton_1 = require("./CreateBlockButton");
var mountCreateBlockButtonInBlock = function (di, mountReactComponent, onClick, isJustBelowFirstBlock, onAddBlockFromMenu, getCreateBlockButtonIndex) {
    var ConnectedCreateButton = di.invoke(CreateBlockButton_1.connectCreateBlockButton);
    return mountReactComponent(react_1.default.createElement(ConnectedCreateButton, { onAddBlock: onAddBlockFromMenu, onClick: onClick, isJustBelowFirstBlock: isJustBelowFirstBlock, getCreateBlockButtonIndex: getCreateBlockButtonIndex }));
};
exports.mountCreateBlockButtonInBlock = mountCreateBlockButtonInBlock;
var initialiseCreateBlockButtonForEmptyProjectContainer = function (di, onAddBlock) {
    var getCreateBlockButtonIndex = function () { return 0; };
    var ConnectedCreateButton = di.invoke(CreateBlockButton_1.connectCreateBlockButton);
    return function () { return (react_1.default.createElement(ConnectedCreateButton, { onAddBlock: onAddBlock, onClick: lodash_1.noop, isJustBelowFirstBlock: true, getCreateBlockButtonIndex: getCreateBlockButtonIndex })); };
};
exports.initialiseCreateBlockButtonForEmptyProjectContainer = initialiseCreateBlockButtonForEmptyProjectContainer;
